import React from "react";

export default function DashboardHeader() {
  return (
    <header className="dashboard-header">
      <h1>🍳 Chefs2Table Operations</h1>
      <p>Internal control panel - not visible to public</p>
    </header>
  );
}
